import { IGatsbyImageData } from 'gatsby-plugin-image'

export interface Mudapin {
  id: string
  name?: string
  series: string
  image: IGatsbyImageData
}

export function tokenizeMudapins(input: string): Array<string> {
  const result: string[] = []
  const re = /(?:logo)?pin\d+/gi

  let match = re.exec(input)
  while (match != null) {
    result.push(match[0])
    match = re.exec(input)
  }

  return result
}

export function parseMudapins(
  allMudapins: Mudapin[],
  input: string,
): Mudapin[] {
  const mudapinsMap: Record<string, Mudapin> = {}
  allMudapins.forEach((mp) => {
    mudapinsMap[mp.id] = mp
  })
  const ids = tokenizeMudapins(input)
  const pins = ids
    .map((id) => mudapinsMap[id])
    .filter((mp): mp is Mudapin => !!mp)

  const uniquePins = Object.values(
    pins.reduce((acc, curr) => {
      if (!acc[curr.id]) acc[curr.id] = curr
      return acc
    }, {} as Record<string, Mudapin>),
  )
  uniquePins.sort(
    (a, b) => a.series?.localeCompare(b.series) || a.id.localeCompare(b.id),
  )

  // TODO: give error for pins that are not found

  return uniquePins
}
